export default __webpack_public_path__ + "static/media/ArrowDown.d185e23e.svg";